module.exports = __webpack_public_path__ + "static/Regulamin-Zajęć-c0ee3f9f795e01a0c688c3db30b5f5c5.pdf";